"use client";

import { QuestionMarkCircleIcon } from "@heroicons/react/24/outline";

import { SoftText } from "@/components/text/SoftText";

export function NoIsolations() {
  return (
    <div className="mt-8 flex flex-col items-center">
      <QuestionMarkCircleIcon className="h-8 w-8 text-gray-500" />
      <SoftText elementType="p" className="mt-2">
        No isolations yet
      </SoftText>
    </div>
  );
}
